// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { contains } = require('lodash');
const PropTypes = require('prop-types');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKStatusIcon = require('components/commons/OKStatusIcon/OKStatusIcon');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');
const {
    documentsRequest,
    personalDocuments,
    urlByDocumentType
} = require('./initialValues');

// @actions
const documentationCenterActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');


class MortgageRequestDocumentationCenterItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadDocument = this.handleDownloadDocument.bind(this);
        this.handleAddDocument = this.handleAddDocument.bind(this);
    }

    getDocumentActionStatus(documentStatus) {
        const { NSType } = this.props;
        if (NSType) {
            const { documentType, NSVivienda } = this.props;
            if (documentType === DOCUMENTS_TYPES.TAS) {
                if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR || documentStatus === DOCUMENTS_STATUS.NONE) {
                    return this.buildAddLink();
                }
            }

            if (documentType === DOCUMENTS_TYPES.TAS_DICT) {
                if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR) {
                    return '';
                }
            }

            if (NSType === 'NS_VIVIENDA') {
                if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR || documentStatus === DOCUMENTS_STATUS.NONE) {
                    return this.buildAddLink();
                }
            }
            /**
             * para los casos donde el documento es NS_FACT o TAS_FACT
             * No se puede agregar link de descarga, pero si existe, se puede descargar
             */
            if (documentType === DOCUMENTS_TYPES.NS_FACT || documentType === DOCUMENTS_TYPES.TAS_FACT) {
                if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR) {
                    return '';
                }
            }

            /**
             * para los casos donde el documento es NS_GARAJE o NS_TRASTERO
             *  si alguno está PEND_VAL o VERIFICADO
             *    no mostrar algún link
             *  si la NSVivienda está (pendiente por validar o verificada) y
             *    si alguno está PEND_APORTAR
             *      no mostrar algún link
             *      mostrar link agregar
             */
            if (NSType === 'NS_GARAJE' || NSType === 'NS_TRASTERO') {
                if (NSVivienda.documentStatus === DOCUMENTS_STATUS.PEND_VAL ||
                    NSVivienda.documentStatus === DOCUMENTS_STATUS.VERIFICADO) {
                    if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR) {
                        return '';
                    }
                }

                if (NSVivienda.documentStatus === DOCUMENTS_STATUS.PEND_APORTAR) {
                    if (documentStatus === DOCUMENTS_STATUS.PEND_APORTAR || documentStatus === DOCUMENTS_STATUS.NONE) {
                        return this.buildAddLink();
                    }
                }
            }

            if (documentStatus === DOCUMENTS_STATUS.PEND_VAL ||
                documentStatus === DOCUMENTS_STATUS.VERIFICADO) {
                return this.buildDownloadButton();
            }

        } else {
            if (
                documentStatus === DOCUMENTS_STATUS.NONE ||
                documentStatus === DOCUMENTS_STATUS.PEND_APORTAR ||
                documentStatus === DOCUMENTS_STATUS.NO_VALIDO
            ) {
                return this.buildAddLink();
            } else {
                return this.buildDownloadButton();
            }
        }
    }

    getUrlLink(documentType) {
        const paramIdHolder = contains(personalDocuments, documentType) ? this.props.idHolder : '';
        return urlByDocumentType[documentType] + paramIdHolder || '';
    }

    buildAddLink() {
        const { documentType } = this.props;
        const labelDocumentAdd = formatText('mortgageRequestDocumentationCenter-documentAdd');
        const labelDocumentAddOrRequest = formatText('mortgageRequestDocumentationCenter-documentAddOrRequest');
        const labelLink = contains(documentsRequest, documentType) ?
            labelDocumentAddOrRequest :
            labelDocumentAdd;
        const urlLink = this.getUrlLink(documentType);

        return (
            <div className="mortgage-request-documentation-center__add-link-container">
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-agregar"
                    children={labelLink}
                    dataToggle={urlLink}
                    onClick={this.handleAddDocument(urlLink)}
                />
            </div>
        );
    }

    buildDownloadButton() {
        const { documentType, documentEstateId, estatesDataState, documentationCenterState, idPrestamo } = this.props;
        const simpleNoteDocumentType = documentType === DOCUMENTS_TYPES.NS_CLI || documentType === DOCUMENTS_TYPES.NS;
        const acquittanceDocumentType = documentType === DOCUMENTS_TYPES.RECIB_HIPO || documentType === DOCUMENTS_TYPES.RECIB_PREST;

        let buttonFlag;

        if (simpleNoteDocumentType) {
            buttonFlag = estatesDataState.get('isFetching');
        } else if (acquittanceDocumentType) {
            buttonFlag = documentationCenterState.getIn(['isFetching', `${documentType}${idPrestamo}`]);
        } else {
            buttonFlag = documentationCenterState.getIn(['isFetching', documentType]);
        }

        const downloadButton = (
            <div className="mortgage-request-documentation-center__download-button-container">
                <OKButton
                    id={`${documentType}-${documentEstateId}`}
                    onClick={this.handleDownloadDocument}
                    size="small"
                    modifier="task"
                    disabled={buttonFlag}
                    loading={buttonFlag}
                >
                    <i className="icon-descargar" />
                </OKButton>
            </div>
        )
        return (
            <OKTooltip
                content="mortgageRequestDocumentationCenter-downloadIcon"
                offset={[0, -15]}
                target={downloadButton}
            />
        );
    }

    handleAddDocument(urlLink) {
        return (evt => {
            (evt) && evt.preventDefault();
            this.props.history.push(urlLink);
        });
    }

    handleDownloadDocument() {
        const {
            getDocument,
            documentType,
            documentEstateId,
            loanId,
            idDocumentType,
            idDocumentNumber,
            getNSDocuments,
            NSType,
        } = this.props;

        if (documentType === DOCUMENTS_TYPES.NS_CLI || documentType === DOCUMENTS_TYPES.NS) {
            getNSDocuments({
                NSType,
                documentType,
                documentEstatesId: documentEstateId,
                idDocumentType,
                idDocumentNumber
            });
        } else if (documentType === DOCUMENTS_TYPES.RECIB_HIPO || documentType === DOCUMENTS_TYPES.RECIB_PREST) {
            getDocument({
                documentType,
                documentEstateId,
                idDocumentType,
                idDocumentNumber,
                loanId
            });
        } else {
            getDocument({
                documentType,
                documentEstateId,
                idDocumentType,
                idDocumentNumber,
                loanId
            });
        }
    }

    render() {
        const {
            documentTypeLabel,
            documentStatus,
        } = this.props;

        const documentStatusIcon = OKStatusIcon({
            status: documentStatus,
            wrapperClasses: "mortgage-request-documentation-center__item__doc",
            documentTypeLabel: documentTypeLabel
        });

        const documentActionStatus = this.getDocumentActionStatus(documentStatus);

        return (
            <li className="mortgage-request-documentation-center__item">
                <div className="row">
                    <div className="col-md-8">
                        {documentStatusIcon}
                    </div>
                    <div className="col-md-4">
                        <div className="mortgage-request-documentation-center__item__actions">
                            {documentActionStatus}
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

MortgageRequestDocumentationCenterItem.propTypes = {
    documentType: PropTypes.string,
    documentTypeLabel: PropTypes.string,
    documentStatus: PropTypes.string,
    documentEstateId: PropTypes.array,
    idHolder: PropTypes.number,
    idDocumentType: PropTypes.string,
    idDocumentNumber: PropTypes.string,
    getDocument: PropTypes.func,
    getNSDocuments: PropTypes.func,
    estatesDataState: PropTypes.object,
    NSVivienda: PropTypes.object,
    NSType: PropTypes.string,
    idPrestamo: PropTypes.number,
    documentationCenterState: PropTypes.object,
    history: PropTypes.object.isRequired,
    loanId: PropTypes.number
}

MortgageRequestDocumentationCenterItem.defaultProps = {
    idHolder: 0,
    documentEstateId: [0]
}

module.exports.MortgageRequestDocumentationCenterItem = connect(state => (
    {
        estatesDataState: state.mortgageRequestEstatesData,
        documentationCenterState: state.mortgageRequestDocumentationCenter
    }),
    {
        getDocument: documentationCenterActions.getDocument,
        getNSDocuments: documentationCenterActions.getNSDocuments
    }
)(withRouter(MortgageRequestDocumentationCenterItem));
